import { createApiDescription } from "../../helperFunctions";

export const inProcessReturnApi = {
    assignReturns: createApiDescription(
        "This API can be called to assign the un-delivered tax returns to specific user.",
        [
            "Returns can only be assigned to one user.",
            "User IDs can be found by calling user management GET APIs."
        ]
    ),
    changeDocumentStatus: createApiDescription(
        "This API can be called to Change the status of un-delivered tax return.",
        [
            "Change Status API supports Callback mechanism, callbackUri can be configured in the request body with callback-api-key in the request header. Once a request is sent from Change Status API, the response will be posted to the configured callback endpoint URL.",
            "Change Status API updates status only to Processing and Review statuses if the given tax return’s status is applicable and won’t update the status with non-applicable statuses."
        ]
    ),
    deleteInProcessReturns: createApiDescription(
        "This API can be called to delete the in-process return.",
        [
            "Permanent deletion of the return from in-process page.",
            "Delete In-Process Returns supports Callback mechanism, callbackUri can be configured in the request body with callback-api-key in the request header."
        ]
    ),
    getInProcessReturns: createApiDescription(
        "In-Process Returns API provides results based on the given filters.",
        ["The results will be based on default value mapped with all filters."]
    )
}